export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing"
  },
  session: {
    expired: "invalidToken",
    invalidToken: "invalidToken",
    thisUserNotActive: "thisUserNotActive"
  },
  getCurrencyList: {
    succeed: "get_currency_list_succeed",
    failed: "get_currency_list_failed"
  },
  addAccount: {
    succeed: "edit_account_succeed",
    failed: "edit_account_failed"
  },
  getAccountList: {
    succeed: "get_account_list_succeed",
    failed: "get_account_list_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountSubList: {
    succeed: "get_account_sub_list_succeed",
    failed: "get_account_sub_list_failed",
    accountIDRequired: "account_id_required"
  },
  getTournamentOPList: {
    succeed: "get_tournament_op_list_succeed",
    failed: "get_tournament_op_list_failed"
  },
  addTournamentOP: {
    succeed: "add_tournament_op_succeed",
    failed: "add_tournament_op_failed",
    systemIDRequired: "system_id_required",
    accountIDRequired: "account_id_required"
  },
  deleteTournamentOP: {
    succeed: "delete_tournament_op_succeed",
    failed: "delete_tournament_op_failed",
    systtemIDRequired: "system_id_required",
    accountIDRequired: "account_id_required"
  },
  password: {
    succeed: "get_account_list_succeed",
    failed: "get_account_list_failed",
    accountIDRequired: "account_id_required",
    newPasswordRequired: "new_password_required"
  },
  updateStatus: {
    succeed: "update_status_succeed",
    failed: "update_status_failed",
    accountIDRequired: "account_id_required",
    statusRequired: "status_required"
  },
  accountIPReset: {
    succeed: "account_ip_reset_succeed",
    failed: "account_ip_reset_failed",
    accountIDRequired: "account_id_required",
    loginIPRequired: "login_id_required"
  },
  accountPTUpdateReset: {
    succeed: "account_pt_reset_succeed",
    failed: "account_pt_reset_failed",
    accountIDRequired: "account_id_required"
  },
  updateCashMode: {
    succeed: "update_cash_mode_succeed",
    failed: "update_cash_mode_failed",
    accountIDRequired: "account_id_required",
    statusRequired: "status_required"
  },
  updateTournament: {
    succeed: "update_tournament_succeed",
    failed: "update_tournament_failed",
    accountIDRequired: "account_id_required",
    statusRequired: "status_required"
  },
  unblockProfile: {
    succeed: "unblock_profile_succeed",
    failed: "unblock_profile_failed",
    profileIDRequired: "profile_id_required"
  },
  updateAccountDetails: {
    succeed: "update_account_details_succeed",
    failed: "update_account_details_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountDetails: {
    succeed: "get_account_details_succeed",
    failed: "get_account_details_failed",
    accountIDRequired: "account_id_required"
  },
  updatePlatform: {
    succeed: "update_platform_succeed",
    failed: "update_platform_failed",
    accountIDRequired: "account_id_required",
    platformCodeRequired: "platform_code_required",
    statusRequired: "status_required"
  },
  getPlatform: {
    succeed: "get_platform_succeed",
    failed: "get_platform_failed",
    accountIDRequired: "account_id_required"
  },
  getPlatformAll: {
    succeed: "get_platform_all_succeed",
    failed: "get_platform_all_failed"
  },
  getPositionTaking: {
    succeed: "get_pt_succeed",
    failed: "get_pt_failed",
    accountIDRequired: "account_id_required"
  },
  getCommission: {
    succeed: "get_cm_succeed",
    failed: "get_cm_failed",
    accountIDRequired: "account_id_required"
  },
  getBetLimit: {
    succeed: "get_bl_succeed",
    failed: "get_bl_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionSB: {
    succeed: "update_commission_sb_succeed",
    failed: "update_commission_sb_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionSL: {
    succeed: "update_commission_sl_succeed",
    failed: "update_commission_sl_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionLC: {
    succeed: "update_commission_lc_succeed",
    failed: "update_commission_lc_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionLO: {
    succeed: "update_commission_lo_succeed",
    failed: "update_commission_lo_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionKN: {
    succeed: "update_commission_kn_succeed",
    failed: "update_commission_kn_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionCF: {
    succeed: "update_commission_cf_succeed",
    failed: "update_commission_cf_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionLT: {
    succeed: "update_commission_lt_succeed",
    failed: "update_commission_lt_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionTN: {
    succeed: "update_commission_tn_succeed",
    failed: "update_commission_tn_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitSB: {
    succeed: "update_bet_limit_sb_succeed",
    failed: "update_bet_limit_sb_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitLC: {
    succeed: "update_bet_limit_lc_succeed",
    failed: "update_bet_limit_lc_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitLO: {
    succeed: "update_bet_limit_lo_succeed",
    failed: "update_bet_limit_lo_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitKN: {
    succeed: "update_bet_limit_kn_succeed",
    failed: "update_bet_limit_kn_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitCF: {
    succeed: "update_bet_limit_cf_succeed",
    failed: "update_bet_limit_cf_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitLT: {
    succeed: "update_bet_limit_lt_succeed",
    failed: "update_bet_limit_lt_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingSB: {
    succeed: "update_position_taking_sb_succeed",
    failed: "update_position_taking_sb_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingSL: {
    succeed: "update_position_taking_sl_succeed",
    failed: "update_position_taking_sl_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingLC: {
    succeed: "update_position_taking_lc_succeed",
    failed: "update_position_taking_lc_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingLO: {
    succeed: "update_position_taking_lo_succeed",
    failed: "update_position_taking_lo_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingKN: {
    succeed: "update_position_taking_kn_succeed",
    failed: "update_position_taking_kn_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingCF: {
    succeed: "update_position_taking_cf_succeed",
    failed: "update_position_taking_cf_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingLT: {
    succeed: "update_position_taking_lt_succeed",
    failed: "update_position_taking_lt_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyWinlose: {
    succeed: "get_daily_winlose_succeed",
    failed: "get_daily_winlose_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyWinloseTournament: {
    succeed: "get_daily_winlose_succeed",
    failed: "get_daily_winlose_failed",
    accountIDRequired: "account_id_required"
  },
  getGameResult: {
    succeed: "get_game_result_succeed",
    failed: "get_game_result_failed",
    accountIDRequired: "account_id_required",
    memberIDRequired: "member_id_required"
  },
  getTournamentJackpot: {
    succeed: "get_tournament_jackpot_succeed",
    failed: "get_tournament_jackpot_failed",
    accountIDRequired: "account_id_required"
  },
  getSettlementList: {
    succeed: "get_settlement_list_succeed",
    failed: "get_settlement_list_failed",
    accountIDRequired: "account_id_required"
  },
  settlement: {
    succeed: "settlement_succeed",
    failed: "settlement_failed",
    accountIDRequired: "account_id_required",
    settleAmountRequired: "settle_amount_required"
  },
  getSettlementHistory: {
    succeed: "get_settlement_history_succeed",
    failed: "get_settlement_history_failed",
    accountIDRequired: "account_id_required"
  },
  getBetList: {
    succeed: "get_betlist_succeed",
    failed: "get_betlist_failed",
    accountIDRequired: "account_id_required",
    betTypeRequired: "bet_type_required"
  },
  getPendingMatches: {
    succeed: "get_pending_matches_succeed",
    failed: "get_pending_matches_failed"
  },
  getPlatformWinlose: {
    succeed: "get_platform_winlose_succeed",
    failed: "get_platform_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  getSportTypeWinlose: {
    succeed: "get_sport_type_winlose_succeed",
    failed: "get_sport_type_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  getLeagueWinlose: {
    succeed: "get_league_winlose_succeed",
    failed: "get_league_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required"
  },
  getMatchWinlose: {
    succeed: "get_match_winlose_succeed",
    failed: "get_match_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required",
    leagueIDRequired: "league_id_required"
  },
  getMatchMemberWinlose: {
    succeed: "get_match_member_winlose_succeed",
    failed: "get_match_member_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required",
    leagueIDRequired: "league_id_required",
    matchIDRequired: "match_id_required"
  },
  getTournamentRefund: {
    succeed: "get_tournament_refund_succeed",
    failed: "get_tournament_refund_failed"
  },
  getMemberLog: {
    succeed: "get_member_log_succeed",
    failed: "get_member_log_failed"
  },
  getLoginIPLog: {
    succeed: "get_login_ip_log_succeed",
    failed: "get_login_ip_log_failed"
  },
  getLoginDetailLog: {
    succeed: "get_login_detail_log_succeed",
    failed: "get_login_detail_log_failed"
  },
  getAccountStatus: {
    succeed: "get_account_status_succeed",
    failed: "get_account_status_failed"
  },
  getMemberVIP: {
    succeed: "get_account_vip_succeed",
    failed: "get_account_vip_failed"
  },
  getLog: {
    urlRequired: "url_required",
    targetIDRequired: "target_id_required"
  },
  getSummary: {
    succeed: "get_summary_succeed",
    failed: "get_summary_failed"
  },
  updateCurrency: {
    succeed: "update_currency_succeed",
    failed: "update_currency_failed",
    currencyRequired: "currency_required",
    rateRequired: "rate_required"
  },
  getParlayDetail: {
    succeed: "get_parlay_detail_succeed",
    failed: "get_parlay_detail_failed",
    betIDRequired: "bet_id_required"
  },
  getEsportsDetailCombo: {
    succeed: "get_esports2_detail_combo_succeed",
    failed: "get_esports2_detail_combo__failed",
    betIDRequired: "bet_id_required"
  },
  getWinMarginSport: {
    succeed: "get_winmargin_sport_succeed",
    failed: "get_winmargin_sport_failed"
  },
  getWinMarginLeague: {
    succeed: "get_winmargin_league_succeed",
    failed: "get_winmargin_league_failed",
    sportTypeRequired: "sport_type_required"
  },
  getWinMarginMatch: {
    succeed: "get_winmargin_match_succeed",
    failed: "get_winmargin_match_failed",
    leagueIdRequired: "league_id_required"
  }
};
